import type { ScrollbarTheme } from './light'
import { commonDark } from '../../../_styles/common'
import { self } from './light'

const scrollbarDark: ScrollbarTheme = {
  name: 'Scrollbar',
  common: commonDark,
  self
}

export default scrollbarDark
